<template>
  <section class="md-section">
    <header v-if="title" class="md-section__head">
      <h2 class="md-section__title">{{ title }}</h2>
      <slot name="head-right"></slot>
    </header>

    <!-- error state (section keeps the rest of the page alive) -->
    <div v-if="error" class="md-section__error">
      <div class="md-section__error-text">{{ error }}</div>
      <b-button size="sm" variant="outline-primary" @click="$emit('retry')">
        {{ $t('mobileDash.retry') }}
      </b-button>
    </div>
    <slot v-else></slot>
  </section>
</template>

<script>
export default {
  name: 'MdSection',
  props: {
    title: { type: String, default: null },
    error: { type: String, default: null },
  },
};
</script>

<style scoped>
.md-section {
  margin-bottom: 1.1rem;
}
.md-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding: 0 0.15rem;
}
.md-section__title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--md-muted, #8a919c);
  margin: 0;
}
.md-section__error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border: 1px dashed rgba(214, 69, 69, 0.4);
  border-radius: 10px;
}
.md-section__error-text {
  font-size: 12.5px;
  color: #d64545;
}
</style>
